import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(private http:HttpClient) { }

  loginUser(userdata:any):Observable<object>{
    return this.http.post(environment.apiURL+'auth/login',userdata)
  }
}
